import { formatAmount } from "@loot-os/api-contract";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@loot-os/ui/components/table";

import { amountColumnHeader, useCurrency } from "../lib/currency";
import { centsToDollars, formatDate } from "../lib/format";
import type { UserDetail } from "../lib/trpc";
import { PurchaseStatusBadge } from "./PurchaseStatusBadge";
import { TableMessageRow } from "./TableMessageRow";

const COLUMNS = 5;

/** The latest top-up purchases from `users.get`: what was paid in dollars, what it credited. */
export function UserPurchasesTab({ rows }: { rows: UserDetail["purchases"] }) {
  const currency = useCurrency();
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Time</TableHead>
          <TableHead>Purchase</TableHead>
          <TableHead className="text-right">Paid</TableHead>
          <TableHead className="text-right">{amountColumnHeader("Credited", currency)}</TableHead>
          <TableHead>Status</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {rows.length === 0 && (
          <TableMessageRow colSpan={COLUMNS}>No purchases yet.</TableMessageRow>
        )}
        {rows.map((purchase) => (
          <TableRow key={purchase.id}>
            <TableCell className="text-muted-foreground">
              {formatDate(purchase.createdAt)}
            </TableCell>
            <TableCell>{purchase.packName}</TableCell>
            <TableCell className="text-right font-mono text-xs">
              {centsToDollars(purchase.amountCents)}
            </TableCell>
            <TableCell className="text-right font-mono text-xs">
              {formatAmount(purchase.creditedCents, currency)}
            </TableCell>
            <TableCell>
              <PurchaseStatusBadge status={purchase.status} />
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
